module.exports = __webpack_public_path__ + "static/media/animated-marker.f58de578.gif";